import { Phone } from 'lucide-react';

export const FloatingCallButton = () => {
  return (
    <a
      href="tel:647-919-6893"
      className="fab-button animate-bounce-slow md:hidden"
      data-testid="floating-call-button"
      aria-label="Call Now"
    >
      <Phone size={28} />
    </a>
  );
};

export default FloatingCallButton;
